export const TODOS_REQUEST = "TODOS_REQUEST";
export const TODOS_SUCCESS = "TODOS_SUCCESS";
export const TODOS_FAIL= "TODOS_FAIL";
export const TODOS_RESET= "TODOS_RESET";

export const ADD_TODO_REQUEST = "ADD_TODO_REQUEST";
export const ADD_TODO_SUCCESS = "ADD_TODO_SUCCESS";
export const ADD_TODO_FAIL= "ADD_TODO_FAIL";
export const ADD_TODO_RESET= "ADD_TODO_RESET";

export const EDIT_TODO_REQUEST = "EDIT_TODO_REQUEST";
export const EDIT_TODO_SUCCESS = "EDIT_TODO_SUCCESS";
export const EDIT_TODO_FAIL= "EDIT_TODO_FAIL";
export const EDIT_TODO_RESET= "EDIT_TODO_RESET";

export const DELETE_TODO_REQUEST = "DELETE_TODO_REQUEST";
export const DELETE_TODO_SUCCESS = "DELETE_TODO_SUCCESS";
export const DELETE_TODO_FAIL= "DELETE_TODO_FAIL";
export const DELETE_TODO_RESET= "DELETE_TODO_RESET";
